
import { useMemo } from "react"
import { GenerateContasReceberParcialColumns } from "../columns"
import { Stack } from "@mui/material"
import { ContasReceberParcial } from "../../../../domain/models/recebimento_parcial"
import { GridRowSelectionModel } from "@mui/x-data-grid"
import { RecebimentoStyledDataGrid } from "./recebimento_data_grid"

type Props = {
    loading: boolean;
    contasReceberParcialLista: ContasReceberParcial[] | [];
    page: number;
    rowsPerPage: number;
    totalItems: number;
    rowSelectionModel: GridRowSelectionModel | undefined;
    statusRecebido: number
    valorTotalParcial: number
    handleContasReceberParcialCadastroOpenState: (openState: boolean) => void;
    handleRowSelectionModelChange: (rows: GridRowSelectionModel) => void;
    handlePageChange: (page: number) => void;
    handleRowsPerPageChange: (rowsPerPage: number) => void;
    handleContasReceberParcialDeleteOpenState: (idContasReceberParcial: number | null, openState: boolean) => void

}


export const RecebimentoParcial = ({
    loading,
    contasReceberParcialLista,
    page,
    rowsPerPage,
    rowSelectionModel,
    statusRecebido,
    valorTotalParcial,
    handleRowSelectionModelChange,
    handleContasReceberParcialCadastroOpenState,
    handlePageChange,
    handleRowsPerPageChange,
    handleContasReceberParcialDeleteOpenState,

}: Props) => {

    const columnsDef = useMemo(() => {
        return GenerateContasReceberParcialColumns({
            onActionDelete: handleContasReceberParcialDeleteOpenState,
            statusRecebido: statusRecebido
        });
    }, [
        handleContasReceberParcialDeleteOpenState, statusRecebido
    ]);

    return (
        <>
            {/* {
                statusRecebido == 4 &&
                <div className="flex w-full flex-row justify-end pb-4">
                    <div className="flex w-60 flex-row items-end pb-4">
                        <PrimaryButton
                            type="button"
                            onClick={() => handleContasReceberParcialCadastroOpenState(true)}
                            startIcon={<DynamicIcon nameIcon="CheckRounded" size={25} className="text-white" />}>
                            Novo Recebimento Parcial.
                        </PrimaryButton>
                    </div>
                </div >
            } */}

            <Stack spacing={0}>
                {/* <div className="w-full flex flex-row justify-between items-stretch">
                    <div className="flex flex-col flex-wrap justify-end">
                        <LegendComponent>
                            <LegendItemComponent
                                icon={<LegendIcon color='gray' title='E' />}
                                label='Em Aberto' />

                            <LegendItemComponent
                                icon={<LegendIcon color='green' title='R' />}
                                label='Recebida' />

                            <LegendItemComponent
                                icon={<LegendIcon color='yellow' title='O' />}
                                label='Outros' />

                            <LegendItemComponent
                                icon={<LegendIcon color='red' title='A' />}
                                label='Atrasadas' />

                        </LegendComponent>
                    </div>

                    <div className="flex flex-col justify-between flex-1">
                        <TablePagination
                            component="div"
                            count={viewModel.pagination.totalItems}
                            page={viewModel.pagination.page - 1}
                            rowsPerPageOptions={[10, 25, 50, 100]}
                            onPageChange={(_, p) => viewModel.handlePageChange(p)}
                            rowsPerPage={viewModel.pagination.rowsPerPage}
                            onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))} />
                    </div>
                </div> */}

                {/* <StyledDataGrid
                    tableName="contas_receber_parcial_lista"
                    disableColumnMenu={false}
                    showToolbar={true}
                    disableRowSelectionOnClick={true}
                    getRowId={(row: ContasReceberParcial) => row.idContasReceberParcial}
                    columns={columnsDef}
                    loading={loading}
                    checkboxSelection={false}
                    onRowSelectionModelChange={handleRowSelectionModelChange}
                    rowSelectionModel={rowSelectionModel}
                    rows={contasReceberParcialLista}
                    rowCount={contasReceberParcialLista.length}
                    pageSizeOptions={[10, 25, 50, 100]}
                    paginationMode="server"
                    paginationModel={{
                        page: page,
                        pageSize: rowsPerPage,
                    }}
                    pinnedColumns={{
                        right: ['idContasReceberParcial'],

                    }}
                /> */}

                <RecebimentoStyledDataGrid
                    tableName="contas_receber_parcial_lista"
                    disableColumnMenu={false}
                    getRowId={(row: ContasReceberParcial) => row.idContasReceberParcial}
                    columns={columnsDef}
                    loading={loading}
                    rows={contasReceberParcialLista}
                    rowCount={contasReceberParcialLista.length}
                    checkboxSelection={false}
                    disableRowSelectionOnClick={true}
                    onRowSelectionModelChange={handleRowSelectionModelChange}
                    rowSelectionModel={rowSelectionModel}
                    pageSizeOptions={[10, 25, 50, 100]}
                    statInformation={valorTotalParcial}
                    paginationMode="server"
                    paginationModel={{
                        page: page,
                        pageSize: rowsPerPage,
                    }} pinnedColumns={{
                        right: ['idContasReceberParcial'],

                    }}
                />

                {/* <TablePagination
                    component="div"
                    count={viewModel.pagination.totalItems}
                    page={viewModel.pagination.page - 1}
                    onPageChange={(_, p) => viewModel.handlePageChange(p)}
                    rowsPerPageOptions={[10, 25, 50, 100]}
                    rowsPerPage={viewModel.pagination.rowsPerPage > 0 ? viewModel.pagination.rowsPerPage : 25}
                    onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))}
                /> */}

            </Stack>

        </>
    )
}